import InsightCard from './InsightCard';

export default InsightCard;

export type { IInsightCardProps } from './InsightCard';
